import React from 'react';

const SectionDivider = () => (
  <hr className="border-0 border-t border-surface-secondary mt-[12px] mb-[36px]" />
);

export default SectionDivider;
